import React, { useState, useEffect, useRef, useCallback } from "react";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import Header from "../../../Header";
import { ToastContainer } from "react-toastify";
import { BsSearch } from "react-icons/bs";
import Pagination from "react-js-pagination";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import useFetchPost from "../hooks/useFetchPost";
import useFetchGet from "../hooks/useFetchGet";
import RaiseCustomInvoice from "../modals/RaiseCustomInvoice";
import MarkAsPaid from "../modals/MarkAsPaid";
import Confirm from "../modals/Confirm";

import DateRangePicker from "rsuite/DateRangePicker";
import CheckPicker from "rsuite/CheckPicker";
import Avatar from "rsuite/Avatar";
import Table from "rsuite/Table";
import "rsuite/CheckPicker/styles/index.css";
// import "rsuite/dist/rsuite.min.css";
import "../../../assets/css/rsuite.css";

import TagPickerValueRenderer from "../TagPickerValueRenderer";
import TagPickerImageValueRenderer from "../TagPickerImageValueRenderer";

import { NavLink, Link, useHistory, useLocation } from "react-router-dom";
import { addDays } from "date-fns";
import moment from "moment";
import { getFormattedDate } from "../../../actions/common";
const predefinedRanges = [
	{
		label: "Today",
		value: [new Date(), new Date()],
		placement: "left",
	},
	{
		label: "Yesterday",
		value: [addDays(new Date(), -1), addDays(new Date(), -1)],
		placement: "left",
	},
	{
		label: "Last 7 Days",
		value: [addDays(new Date(), -7), new Date()],
		placement: "left",
	},
	{
		label: "Last 30 Days",
		value: [addDays(new Date(), -30), new Date()],
		placement: "left",
	},
];

const statusData = ["Draft", "Due", "Paid", "Lost"].map((item) => ({ label: item, value: item }));
let dealsFilterArr = [
	"customer_id",
	"product_key",
	"deal_name",
	"deal_value",
	"deal_state",
	"deal_description",
	"deal_status",
];
let milestoneFilterDateArr = ["milestone_due", "milestone_receive", "created_at"];
const dealStates = ["Warm", "Hot", "Cold"].map((item) => ({ label: item, value: item }));
const dealStatus = [
	{ label: "Open", value: true },
	{ label: "Close", value: false },
].map((item) => ({ label: item.label, value: item.value }));

// const currentUnixTime = Math.floor(Date.now() / 1000);
const currentUnixTime = new Date().toLocaleDateString("en-CA");
const DealsOld = () => {
	const history = useHistory();
	const location = useLocation();

	const [storePermission, setStorePermission] = useState(localStorage.getItem("store_permission"));
	const [isGeneralUser, setIsGeneralUser] = useState(localStorage.getItem("is_general_user"));
	const { fetchData } = useFetchGet();
	const { fetchPostData } = useFetchPost();
	const [dealsList, setDealsList] = useState([]);
	const [loading, setLoading] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setperPage] = useState(20);
	const [totalCount, setTotalCount] = useState(0);
	const [offSet, setoffSet] = useState(0);
	const [order, setOrder] = useState("desc");
	const [sort, setSort] = useState("created_at");
	const [productData, setProductData] = useState([]);
	// Object to track sort state for each field
	const [sortStates, setSortStates] = useState({
		deal_name: "default",
		milestone_due: "default",
		milestone_amount: "default",
		milestone_receive: "default",
		milestone_id: "default",
	});

	const [filterColor, setFilterColor] = useState({});
	const [showShortIcon, setShowShortIcon] = useState(true);

	const [search, setSearch] = useState("");
	const [searchTemp, setSearchTemp] = useState("");

	const [showFilter, setShowFilter] = useState(false);
	const [stateData, setStateData] = useState([]);
	const [stateLoading, setStateLoading] = useState(false);
	const [inputValue, setInputValue] = useState({});
	const [inputTemp, setInputTemp] = useState({});

	const [apiRun, setApiRun] = useState(false);
	const [raiseCustomInvoiceModalData, setRaiseCustomInvoiceModalData] = useState(null);
	const [markAsPaidModalData, setMarkAsPaidModalData] = useState(null);
	const [confirmModalData, setConfirmModalData] = useState(null);

	const [acManager, setAcManager] = useState([]);
	const [tseOwner, setTseOwner] = useState([]);
	const [slManager, setSlManager] = useState([]);
	const [accountManagerData, setAccountManagerData] = useState([]);
	const [salesManagerData, setSalesManagerData] = useState([]);
	const [tseOwnerData, setTseOwnerData] = useState([]);
	const [isAccountManagerLoading, setIsAccountManagerLoading] = useState(false);
	const [isSalesManagerLoading, setIsSalesManagerLoading] = useState(false);
	const [isTseOwnerLoading, setIsTseOwnerManagerLoading] = useState(false);

	// Parse query parameters for url encrypt and dcrypt
	const searchParams = new URLSearchParams(location.search);
	const queryString = searchParams.get("debug");
	const debug = queryString == null || queryString == "false" ? false : true;

	// filter created by and created date
	const [userList, setUserList] = useState([]);
	const [selectedUserEmail, setSelectedUserEmail] = useState("");
	const [allDeals, setAllDeals] = useState([]);
	const [filteredDeals, setFilteredDeals] = useState([]);

	function decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	function decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}

	/**
	 * Searchbox code Start
	 */
	// Define the debounce function
	const customDebounce = (func, delay) => {
		let timer;
		return function (...args) {
			const context = this;
			if (timer) clearTimeout(timer);
			timer = setTimeout(() => {
				timer = null;
				func.apply(context, args);
			}, delay);
		};
	};
	// Define the search handler function
	const searchHandler = (searchTerm) => {
		setSearch(searchTerm);
	};

	// Memoize the debounced search handler using useCallback
	const debouncedSearchHandler = useCallback(
		customDebounce(searchHandler, 500), // Adjust the delay as needed
		[] // Empty dependency array ensures the callback is memoized only once
	);
	// Handle input change
	const handleInputChange = (event) => {
		const searchTerm = event.target.value; // Extract the value from the event
		setSearchTemp(searchTerm);
		debouncedSearchHandler(searchTerm); // Pass searchTerm to debouncedSearchHandler
	};
	/**
	 * Searchbox code End
	 */
	const getProduct = async () => {
		try {
			const responseProductData = await fetchData(`${process.env.REACT_APP_INTRANET_API}/tattle/productList`);
			setProductData(responseProductData);
		} catch (error) {
			console.error("Error:", error);
		}
	};

	function removeEmptyValues(obj) {
		for (let key in obj) {
			if (obj.hasOwnProperty(key) && (obj[key] === "" || (Array.isArray(obj[key]) && obj[key].length === 0))) {
				delete obj[key];
			}
		}
		return obj;
	}

	useEffect(() => {
		fetch(`${process.env.REACT_APP_CRM}/user-list`, {
			method: "POST",
		})
			.then((resp) => resp.json())
			.then((data) => {
				if (data.code === 200) {
					const userListArray = Object.values(data.data);
					setUserList(userListArray);
				} else {
					console.error("Invalid response or no users available:", data);
					setUserList([]);
				}
			})
			.catch((error) => {
				console.error("Error fetching user list:", error);
				setUserList([]);
			});
	}, []);

	// Helper function to apply all active filters
	const applyFilters = (filters = {}) => {
		let filtered = [...allDeals];

		// Apply "Created By" filter if it's set
		if (filters.selectedUserEmail && filters.selectedUserEmail.length > 0) {
			filtered = filtered.filter((deal) => {
				const createdByUserUUID =
					deal.deals && deal.deals.user && deal.deals.user.user_uuid;
				return createdByUserUUID && filters.selectedUserEmail.includes(createdByUserUUID);
			});
		}

		// Apply other advanced filters
		if (Object.keys(filters.inputValue || {}).length > 0) {
			Object.keys(filters.inputValue).forEach((key) => {
				if (filters.inputValue[key]) {
					filtered = filtered.filter((deal) => deal[key] === filters.inputValue[key]);
				}
			});
		}

		// Update the filtered deals state
		setFilteredDeals(filtered);
	};

	const getDealsData = (current_page) => {
		const requestBody = {
			per_page: perPage,
			current_page: search !== "" ? 1 : current_page,
			filter: { deal: {} },
		};

		if (sort) {
			requestBody.sort = sort;
			requestBody.order = order;
		}

		// Add or remove "Created By" filter dynamically
		if (selectedUserEmail && selectedUserEmail.length > 0) {
			requestBody.filter.deal.user_uuid = selectedUserEmail;
		} else {
			delete requestBody.filter.deal.user_uuid;
		}

		//console.log("Filter Data", inputValue);

		// Add the search parameter to the request body if it's not null
		if (search !== "") {
			requestBody.search = search;
		}

		let dealsFilteredData = {};
		let mileStoneFilteredDateeRangeData = {};
		let filteredData = {};

		// Check Advanced filter objects not empty
		let myObject2 = removeEmptyValues(inputValue);
		if (Object.keys(myObject2).length >= 1) {
			for (const key in myObject2) {
				if (myObject2.hasOwnProperty(key)) {
					//console.log(`${key}: ${myObject2[key]}`);
					if (dealsFilterArr.includes(key)) {
						dealsFilteredData[key] = myObject2[key];
					} else if (milestoneFilterDateArr.includes(key)) {
						let dateArray = myObject2[key].split(" ~ ").map((date) => date.trim());
						mileStoneFilteredDateeRangeData[key] = dateArray;
					} else {
						filteredData[key] = myObject2[key];
					}
				}
			}
		}
		// Initialize requestBody.filter if it's not already initialized
		requestBody.filter = requestBody.filter || {};

		// Initialize requestBody.filter.crm_user if it's not already initialized
		requestBody.filter.milestone = requestBody.filter.milestone || {};

		// Initialize requestBody.filter.crm_user if it's not already initialized
		requestBody.filter.deal = requestBody.filter.deal || {};

		// Add the filtered data to requestBody if there is any matched data
		if (Object.keys(dealsFilteredData).length > 0) {
			requestBody.filter.deal = {
				...requestBody.filter.deal,
				...dealsFilteredData,
			};
		}

		if (Object.keys(mileStoneFilteredDateeRangeData).length > 0) {
			requestBody.filter.milestone = {
				...requestBody.filter.milestone,
				range: mileStoneFilteredDateeRangeData,
			};
		}

		if (Object.keys(filteredData).length > 0) {
			requestBody.filter.milestone = {
				...requestBody.filter.milestone,
				...filteredData,
			};
		}
		if (
			(acManager && acManager.length >= 1) ||
			(tseOwner && tseOwner.length >= 1) ||
			(slManager && slManager.length >= 1)
		) {
			// Update requestBody.filter.crm_user only with non-empty arrays
			requestBody.filter.deal = {
				...requestBody.filter.crm_user,
				...(acManager && acManager.length > 0 ? { account_manager: acManager } : {}),
				...(tseOwner && tseOwner.length > 0 ? { tse_owner: tseOwner } : {}),
				...(slManager && slManager.length > 0 ? { sales_manager: slManager } : {}),
			};
		}
		fetch(`${process.env.REACT_APP_CRM}/crm/deal-list`, {
			method: "POST",
			body: JSON.stringify(requestBody),
		})
			.then((res) => {
				if (!res.ok) {
					throw new Error(`HTTP error! Status: ${res.status}`);
				}
				return res.json();
			})
			.then((data) => {
				if (data && data.code == 200) {
					setLoading(false);
					//console.log("Deals Data Before Set:", data.data);
					setDealsList(data.data || []);
					//console.log("Deals Data After Set:", data.data);
					setAllDeals(data.data || []);
					setTotalCount(data.total_count);
					setoffSet(data.offset);
					setperPage(data.per_page);
					applyFilters({
						selectedUserEmail,
						inputValue,
					});
				} else {
					setLoading(false);
					setDealsList([]);
					setAllDeals([]);
					setTotalCount(0);
					throw new Error(`API error! Code: ${data.code}`);
				}
			})
			.catch((error) => {
				console.error("Fetch error:", error.message);
				// Handle fetch error
			});
	};

	const handleCreatedByChange = (value) => {
		setSelectedUserEmail(value);

		if (value.length === 0) {
			const updatedFilters = { ...inputValue };
			delete updatedFilters.user_uuid;
			setInputValue(updatedFilters);
		}
	};

	function handlePageChange(pageNumber = 1) {
		setCurrentPage(pageNumber);
		getDealsData(pageNumber);
	}

	useEffect(() => {
		document.title = "Intranet | Deals";
		getDealsData(currentPage);
		getProduct();
		//console.log("custerpage running iside use effect...");
	}, [currentPage, search, sort, order, inputValue, apiRun, acManager, tseOwner, slManager, selectedUserEmail]);

	/**
	 * Reset Button Code Start
	 *Reset All filter state in TableHeader Component - tocall
	 */
	const resetHandler = () => {
		setSearchTemp("");
		setSearch("");
		setInputValue({});
		setInputTemp({});
		setAcManager([]);
		setTseOwner([]);
		setSlManager([]);
		setSelectedUserEmail("");
		applyFilters({
			selectedUserEmail: "",
			inputValue: {},
		});
	};
	/**
	 * Extra Filter Start
	 */
	const getDealState = async () => {
		setStateLoading(true);
		try {
			const responseData = await fetchData(`${process.env.REACT_APP_CRM}/crm/get-deal-state-list`);
			if (responseData.code == 200) {
				setStateData(responseData.data);
				setStateLoading(false);
			}
		} catch (error) {
			setStateLoading(false);
			console.error("Error:", error);
		}
	};

	const handleSelectChange = (name) => (value) => {
		setInputValue((prevInputValue) => ({
			...prevInputValue,
			[name]: value, // Update inputValue with the selected values
		}));
		setInputTemp((prevInputValue) => ({
			...prevInputValue,
			[name]: [...value], // Update inputValue with the selected values
		}));
	};
	const handleApplyTime = (name) => (value) => {
		const formattedDates = value.map((date) => moment(date).format("YYYY-MM-DD"));
		let finalStartDate = formattedDates[0];
		let finalEndDate = formattedDates[1];

		setInputValue((prevInputValue) => ({
			...prevInputValue,
			[name]: `${finalStartDate} ~ ${finalEndDate}`, // Update inputValue with the selected values
		}));
		setInputTemp((prevInputValue) => ({
			...prevInputValue,
			[name]: value, // Update inputValue with the selected values
		}));
	};
	const handleCleanDate = (name) => (value) => {
		setInputValue((prevInputValue) => ({
			...prevInputValue,
			[name]: "", // Update inputValue with the selected values
		}));
		setInputTemp((prevInputValue) => ({
			...prevInputValue,
			[name]: null, // Update inputValue with the selected values
		}));
	};
	const handleChangeDate = (name) => (value) => {
		// `value` will contain the new date range selection
		if (!value) {
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				[name]: "", // Update inputValue with the selected values
			}));
			setInputTemp((prevInputValue) => ({
				...prevInputValue,
				[name]: null, // Update inputValue with the selected values
			}));
		} else {
			// Perform any other actions based on the new date range value
			const formattedDates = value.map((date) => moment(date).format("YYYY-MM-DD"));
			let finalStartDate = formattedDates[0];
			let finalEndDate = formattedDates[1];
			window.localStorage.setItem("created_date_temp", JSON.stringify(value));
			window.localStorage.setItem(name, JSON.stringify(`${finalStartDate} ~ ${finalEndDate}`));
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				[name]: `${finalStartDate} ~ ${finalEndDate}`, // Update inputValue with the selected values
			}));
			setInputTemp((prevInputValue) => ({
				...prevInputValue,
				[name]: value, // Update inputValue with the selected values
			}));
		}
	};
	const getAccountManager = async () => {
		setIsAccountManagerLoading(true);
		try {
			const responseData = await fetchData(
				`${decryptconfigdata("apiUrl")}/tattle/GetGroupMembers?email=accountmanagement@muvi.com`
			);
			if (responseData.code == 200) {
				setAccountManagerData(responseData.data);
				setIsAccountManagerLoading(false);
			} else {
				setAccountManagerData([]);
				setIsAccountManagerLoading(false);
			}
		} catch (error) {
			setIsAccountManagerLoading(false);
			console.error("Error:", error);
		}
	};
	const getSalesManager = async () => {
		setIsSalesManagerLoading(true);
		try {
			const responseData = await fetchData(
				`${decryptconfigdata("apiUrl")}/tattle/GetGroupMembers?email=sales@muvi.com`
			);
			if (responseData.code == 200) {
				setSalesManagerData(responseData.data);
				setIsSalesManagerLoading(false);
			} else {
				setSalesManagerData([]);
				setIsSalesManagerLoading(false);
			}
		} catch (error) {
			setIsSalesManagerLoading(false);
			console.error("Error:", error);
		}
	};
	const getTseOwnerManager = async () => {
		setIsTseOwnerManagerLoading(true);
		try {
			const responseData = await fetchData(
				`${decryptconfigdata("apiUrl")}/tattle/GetGroupMembers?email=support@muvi.com`
			);
			if (responseData.code == 200) {
				setTseOwnerData(responseData.data);
				setIsTseOwnerManagerLoading(false);
			} else {
				setTseOwnerData([]);
				setIsTseOwnerManagerLoading(false);
			}
		} catch (error) {
			setIsTseOwnerManagerLoading(false);
			console.error("Error:", error);
		}
	};

	function showAdvFilter(divId) {
		if (divId == "adv_filter") {
			setShowFilter(!showFilter);
		}
	}
	function getFilter() {
		return (
			<div id="adv_filter" className={`adv_filter filter-wrap ${showFilter ? "show" : ""} `}>
				<div className="containerfull">
					<div className="row">
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Due Date</label>
								<DateRangePicker
									showOneCalendar
									ranges={predefinedRanges}
									onOk={handleApplyTime("milestone_due")}
									onClean={handleCleanDate("milestone_due")}
									onChange={handleChangeDate("milestone_due")}
									value={
										inputTemp.hasOwnProperty("milestone_due") ? inputTemp["milestone_due"] : null
									}
									block={true}
								/>
							</div>
						</div>
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Received Date</label>
								<DateRangePicker
									showOneCalendar
									ranges={predefinedRanges}
									onOk={handleApplyTime("milestone_receive")}
									onClean={handleCleanDate("milestone_receive")}
									onChange={handleChangeDate("milestone_receive")}
									value={
										inputTemp.hasOwnProperty("milestone_receive")
											? inputTemp["milestone_receive"]
											: null
									}
									block={true}
								/>
							</div>
						</div>
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Deal State</label>
								<CheckPicker
									data={dealStates}
									value={inputTemp.hasOwnProperty("deal_state") ? inputTemp["deal_state"] : []}
									onChange={handleSelectChange("deal_state")}
									style={{
										width: "100%",
										zIndex: 1050,
									}}
									block={true}
									searchable={false}
									placeholder="Select Deal State"
								// onOpen={() => getDealState()}
								// loading={stateLoading}
								/>
							</div>
						</div>
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Deal Status</label>
								<CheckPicker
									data={dealStatus}
									value={inputTemp.hasOwnProperty("deal_status") ? inputTemp["deal_status"] : []}
									onChange={handleSelectChange("deal_status")}
									style={{
										width: "100%",
										zIndex: 1050,
									}}
									block={true}
									searchable={false}
									placeholder="Select Deal Status"
								// onOpen={() => getDealState()}
								// loading={stateLoading}
								/>
							</div>
						</div>
					</div>
					<br />
					<div className="row">
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Payment Status</label>
								<CheckPicker
									data={statusData}
									value={
										inputTemp.hasOwnProperty("milestone_status")
											? inputTemp["milestone_status"]
											: []
									}
									onChange={handleSelectChange("milestone_status")}
									style={{
										width: "100%",
										zIndex: 1050,
									}}
									block={true}
									searchable={false}
									placeholder="Select Payment Status"
								// onOpen={() => getDealState()}
								// loading={stateLoading}
								/>
							</div>
						</div>
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Account Manager</label>
								<CheckPicker
									data={accountManagerData.map((item) => {
										return {
											label: item.name,
											value: item.user_uuid,
											imgUrl: item.attachment,
										};
									})}
									value={acManager}
									onChange={setAcManager}
									style={{ width: "100%", zIndex: 1050 }}
									block={true}
									placeholder="Select Account Manager"
									renderMenuItem={(label, item) => (
										<div style={{ display: "flex", alignItems: "center" }}>
											<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 10 }} />
											{label}
										</div>
									)}
									// renderValue={(value, items) => (
									// 	<div
									// 		style={{
									// 			display: "flex",
									// 			alignItems: "center",
									// 			flexWrap: "wrap",
									// 		}}
									// 	>
									// 		{items.map((item) => (
									// 			<div
									// 				key={item.value}
									// 				style={{
									// 					display: "flex",
									// 					alignItems: "center",
									// 					marginRight: 10,
									// 				}}
									// 			>
									// 				<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 5 }} />
									// 				<span>{item.label}</span>
									// 			</div>
									// 		))}
									// 	</div>
									// )}
									renderValue={(value, items) => <TagPickerImageValueRenderer items={items} />}
									onOpen={() => getAccountManager()}
									loading={isAccountManagerLoading}
								/>
							</div>
						</div>
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Sales Manager</label>
								<CheckPicker
									data={salesManagerData.map((item) => {
										return {
											label: item.name,
											value: item.user_uuid,
											imgUrl: item.attachment,
										};
									})}
									value={slManager}
									onChange={setSlManager}
									style={{ width: "100%", zIndex: 1050 }}
									block={true}
									placeholder="Select Sales Manager"
									renderMenuItem={(label, item) => (
										<div style={{ display: "flex", alignItems: "center" }}>
											<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 10 }} />
											{label}
										</div>
									)}
									// renderValue={(value, items) => (
									// 	<div
									// 		style={{
									// 			display: "flex",
									// 			alignItems: "center",
									// 			flexWrap: "wrap",
									// 		}}
									// 	>
									// 		{items.map((item) => (
									// 			<div
									// 				key={item.value}
									// 				style={{
									// 					display: "flex",
									// 					alignItems: "center",
									// 					marginRight: 10,
									// 				}}
									// 			>
									// 				<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 5 }} />
									// 				<span>{item.label}</span>
									// 			</div>
									// 		))}
									// 	</div>
									// )}
									renderValue={(value, items) => <TagPickerImageValueRenderer items={items} />}
									onOpen={() => getSalesManager()}
									loading={isSalesManagerLoading}
								/>
							</div>
						</div>
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">TSE Owner</label>
								<CheckPicker
									data={tseOwnerData.map((item) => {
										return {
											label: item.name,
											value: item.user_uuid,
											imgUrl: item.attachment,
										};
									})}
									value={tseOwner}
									onChange={setTseOwner}
									style={{ width: "100%", zIndex: 1050 }}
									block={true}
									placeholder="Select TSE Owner"
									renderMenuItem={(label, item) => (
										<div style={{ display: "flex", alignItems: "center" }}>
											<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 10 }} />
											{label}
										</div>
									)}
									// renderValue={(value, items) => (
									// 	<div
									// 		style={{
									// 			display: "flex",
									// 			alignItems: "center",
									// 			flexWrap: "wrap",
									// 		}}
									// 	>
									// 		{items.map((item) => (
									// 			<div
									// 				key={item.value}
									// 				style={{
									// 					display: "flex",
									// 					alignItems: "center",
									// 					marginRight: 10,
									// 				}}
									// 			>
									// 				<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 5 }} />
									// 				<span>{item.label}</span>
									// 			</div>
									// 		))}
									// 	</div>
									// )}
									renderValue={(value, items) => <TagPickerImageValueRenderer items={items} />}
									onOpen={() => getTseOwnerManager()}
									loading={isTseOwnerLoading}
								/>
							</div>
						</div>
					</div>
					<br />
					<div className="row">
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Created Date</label>
								<DateRangePicker
									showOneCalendar
									ranges={predefinedRanges}
									onOk={handleApplyTime("created_at")}
									onClean={handleCleanDate("created_at")}
									onChange={handleChangeDate("created_at")}
									value={
										inputTemp.hasOwnProperty("created_at") ? inputTemp["created_at"] : null
									}
									block={true}
								/>
							</div>
						</div>
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Created By</label>
								<CheckPicker
									data={Array.isArray(userList)
										? userList.map((user) => ({
											label: user.name || "Unknown",
											value: user.user_uuid || "",
											imgUrl: user.attachment || "", // <-- Add this line
										}))
										: []
									}
									value={selectedUserEmail || []}
									onChange={handleCreatedByChange}
									style={{ width: "100%", zIndex: 1050 }}
									block
									placeholder="Select Employee"
									renderMenuItem={(label, item) => (
										<div style={{ display: "flex", alignItems: "center" }}>
											<Avatar
												src={item.imgUrl}
												size="xs"
												circle
												style={{ marginRight: 10 }}
											/>
											{label}
										</div>
									)}
									renderValue={(value, items) =>
										value.length === 0 ? (
											<span style={{ color: "#ccc" }}>Select Employee</span>
										) : (
											<TagPickerImageValueRenderer items={items} />
										)
									}
								/>

							</div>
						</div>

					</div>
				</div>
			</div>
		);
	}

	const handleEditDeal = (deal_uuid) => {
		history.push("/deal/" + deal_uuid);
	};

	const handleClickRaiseCustomInvoiceModal = (value) => {
		setRaiseCustomInvoiceModalData({
			product_key: value.deals.product_key,
			customer_user_uuid: value.deals.user.customer_user_uuid,
			customer_tattle_uuid: value.deals.customer_tattle_uuid,
			enterprise_api_gateway_url: value.deals.user.enterprise_api_gateway_url,
			server_id: value.deals.user.server_id ? value.deals.user.server_id : 0,
			milestone_uuid: value.milestone_uuid,
			isDeal: true,
			milestone_amount: value.milestone_amount,
			debug,
		});
		const raiseCustomInvoice = document.getElementById("raiseCustomInvoice");
		// Open the modal
		raiseCustomInvoice.classList.add("show");
		raiseCustomInvoice.style.display = "block";
	};
	const handleClickMarkAsPaidModal = (value) => {
		setMarkAsPaidModalData({
			product_key: value.deals.product_key,
			customer_user_uuid: value.deals.user.customer_user_uuid,
			milestone_uuid: value.milestone_uuid,
			deal_uuid: value.deal_uuid,
		});
		const markAsPaid = document.getElementById("markAsPaid");
		// Open the modal
		markAsPaid.classList.add("show");
		markAsPaid.style.display = "block";
	};
	const handleClickConfirmModal = (confirmText, product_key, user_uuid) => {
		setConfirmModalData({
			confirmText,
			product_key,
			user_uuid,
		});

		const confirmModal = document.getElementById("confirmModal");
		// Open the modal
		confirmModal.classList.add("show");
		confirmModal.style.display = "block";
	};

	// const showActionColumnData = (value) => {
	// 	if (storePermission == 1) {
	// 		if (value["milestone_status"] == "Draft") {
	// 			return (
	// 				<ul className="dropdown-menu list-group dropdownMenuItems" aria-labelledby="dropdownMenu2">
	// 					{/* <li
	// 					className="list-group-item"
	// 					data-toggle="modal"
	// 					data-target="#confirmModal"
	// 					onClick={() =>
	// 						handleClickConfirmModal(
	// 							`Are you sure to login this store '${value.deals.user["company_name"]}'?`,
	// 							value.deals.product_key,
	// 							value.deals.user.customer_user_uuid
	// 						)
	// 					}
	// 					data-keyboard="false"
	// 					data-backdrop="static"
	// 				>
	// 					Login To Account
	// 				</li> */}
	// 					<li
	// 						className="list-group-item"
	// 						data-toggle="modal"
	// 						data-target="#raiseCustomInvoice"
	// 						data-keyboard="false"
	// 						data-backdrop="static"
	// 						onClick={() => handleClickRaiseCustomInvoiceModal(value)}
	// 					>
	// 						Raise Invoice
	// 					</li>
	// 					<li
	// 						className="list-group-item"
	// 						data-toggle="modal"
	// 						data-target="#markAsPaid"
	// 						data-keyboard="false"
	// 						data-backdrop="static"
	// 						onClick={() => handleClickMarkAsPaidModal(value)}
	// 					>
	// 						Mark as Paid
	// 					</li>
	// 					<li className="list-group-item" onClick={() => handleEditDeal(value["deal_uuid"])}>
	// 						Edit
	// 					</li>
	// 				</ul>
	// 			);
	// 		} else if (value["milestone_status"] == "Due") {
	// 			return (
	// 				<ul className="dropdown-menu list-group dropdownMenuItems" aria-labelledby="dropdownMenu2">
	// 					{/* <li
	// 					className="list-group-item"
	// 					data-toggle="modal"
	// 					data-target="#confirmModal"
	// 					onClick={() =>
	// 						handleClickConfirmModal(
	// 							`Are you sure to login this store '${value.deals.user["company_name"]}'?`,
	// 							value.deals.product_key,
	// 							value.deals.user.customer_user_uuid
	// 						)
	// 					}
	// 					data-keyboard="false"
	// 					data-backdrop="static"
	// 				>
	// 					Login To Account
	// 				</li> */}
	// 					<li
	// 						className="list-group-item"
	// 						data-toggle="modal"
	// 						data-target="#markAsPaid"
	// 						data-keyboard="false"
	// 						data-backdrop="static"
	// 						onClick={() => handleClickMarkAsPaidModal(value)}
	// 					>
	// 						Mark as Paid
	// 					</li>
	// 					<li className="list-group-item" onClick={() => handleEditDeal(value["deal_uuid"])}>
	// 						Edit
	// 					</li>
	// 				</ul>
	// 			);
	// 		} else {
	// 			return (
	// 				<ul className="dropdown-menu list-group dropdownMenuItems" aria-labelledby="dropdownMenu2">
	// 					{/* <li
	// 					className="list-group-item"
	// 					data-toggle="modal"
	// 					data-target="#confirmModal"
	// 					onClick={() =>
	// 						handleClickConfirmModal(
	// 							`Are you sure to login this store '${value.deals.user["company_name"]}'?`,
	// 							value.deals.product_key,
	// 							value.deals.user.customer_user_uuid
	// 						)
	// 					}
	// 					data-keyboard="false"
	// 					data-backdrop="static"
	// 				>
	// 					Login To Account
	// 				</li> */}
	// 					{/* <li className="list-group-item" data-toggle="modal" data-target="#confirmModal12" data-keyboard="false" data-backdrop="static">
	// 					Show Transaction Info
	// 				</li> */}
	// 					<li className="list-group-item" onClick={() => handleEditDeal(value["deal_uuid"])}>
	// 						Edit
	// 					</li>
	// 				</ul>
	// 			);
	// 		}
	// 	} else {
	// 		return (
	// 			<ul className="dropdown-menu list-group dropdownMenuItems" aria-labelledby="dropdownMenu2">
	// 				<li className="list-group-item" onClick={() => handleEditDeal(value["deal_uuid"])}>
	// 					Edit
	// 				</li>
	// 			</ul>
	// 		);
	// 	}
	// };

	const showActionColumnData = (value) => {
		if (storePermission == 1) {
			const status = value["milestone_status"];
			const showRaiseInvoice = status === "Draft";
			const showMarkAsPaid = status !== "Paid" && status !== "Lost";

			return (
				<ul className="dropdown-menu list-group dropdownMenuItems" aria-labelledby="dropdownMenu2">

					{showRaiseInvoice && (
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#raiseCustomInvoice"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickRaiseCustomInvoiceModal(value)}
						>
							Raise Invoice
						</li>
					)}

					{showMarkAsPaid && (
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#markAsPaid"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickMarkAsPaidModal(value)}
						>
							Mark as Paid
						</li>
					)}

					<li className="list-group-item" onClick={() => handleEditDeal(value["deal_uuid"])}>
						Edit
					</li>
				</ul>
			);
		} else {
			return (
				<ul className="dropdown-menu list-group dropdownMenuItems" aria-labelledby="dropdownMenu2">
					<li className="list-group-item" onClick={() => handleEditDeal(value["deal_uuid"])}>
						Edit
					</li>
				</ul>
			);
		}
	};

	const handleDescShort = (field) => {
		setShowShortIcon(false);
		setSort(field);
		setOrder("desc");
	};
	const handleAscShort = (field) => {
		setShowShortIcon(true);
		setSort(field);
		setOrder("asc");
	};
	const addShortFilter = (field) => {
		return sort == field && showShortIcon ? (
			<FaCaretUp style={{ color: sort === field ? "#52b7ed" : "" }} onClick={() => handleDescShort(field)} />
		) : (
			<FaCaretDown style={{ color: sort === field ? "#52b7ed" : "" }} onClick={() => handleAscShort(field)} />
		);
	};

	// Function to handle sorting change
	const onSortChange = (field) => {
		let nextSort;
		let nextOrder;

		if (sortStates[field] === "down") {
			nextSort = "up";
			nextOrder = "asc"; // Ascending sorting
			handleAscShort(field);
		} else {
			nextSort = "down";
			nextOrder = "desc"; // Descending sorting
			handleDescShort(field);
		}

		// ✅ Update sorting state
		setSortStates((prevSortStates) => {
			const updatedSortStates = Object.keys(prevSortStates).reduce((acc, key) => {
				acc[key] = key === field ? nextSort : "default";
				return acc;
			}, {});
			return updatedSortStates;
		});

		setSort(field);
		setOrder(nextOrder);
	};

	const sortTypes = {
		default: { class: "sort", fn: (a, b) => a },
		up: { class: "sort-up", fn: (a, b) => a - b },
		down: { class: "sort-down", fn: (a, b) => b - a },
	};

	// Determine icon color based on whether it's active
	const getIconStyle = (field) => {
		return sortStates[field] !== "default"
			? { color: "#006efa" } // Active icon color
			: { color: "black" }; // Default icon color
	};

	const getProductNames = (product_keys) => {
		const result = productData
			.filter((item) => product_keys.includes(item.id)) // Find items where 'id' matches the keys
			.map((item) => item.value) // Map the result to 'value' field
			.join(", ");
		return result;
	};
	function truncateStringAfterWords(str, numWords) {
		const words = str.split(" ");
		if (words.length > numWords) {
			return words.slice(0, numWords).join(" ") + " ...";
		}
		return str;
	}
	function convertUnixTimeStampToDate(unixTimestamp) {
		if (unixTimestamp) {
			const date = new Date(unixTimestamp * 1000).toLocaleDateString("en-CA");
			return date;
		}
	}

	return (
		<div>
			<Header brecum_name="Deals" brecum_page="Deals" />
			<ToastContainer />

			<div className="right_col">
				<div className="customer-wrap">
					<div className="page-top" style={{ padding: "16px 0 0px" }}>
						<div className="containerfull title" style={{ padding: "0px 0px" }}>
							<div className="row">
								<div className="col-md-7">
									<div className="row">
										<div className="col-md-6">
											<div className="mt-10">
												<div className="d-flex align-items-center">
													<h2>
														Deals <span class="badge-blue">{totalCount}</span>
													</h2>
												</div>
											</div>
										</div>
									</div>
								</div>
								{/* Serch Box */}
								<div className="col-md-5">
									<div className="d-flex" style={{ padding: "5px 0px 0px 0px" }}>
										<div className="lct-form-group" style={{ height: "37px" }}>
											<button
												type="submit"
												style={{
													background: "#fff",
													padding: "8px 3px 8px 11px",
												}}
											>
												<BsSearch />
											</button>
											<input
												placeholder="Search"
												type="text"
												className="form-control input-f"
												name="search"
												id="search"
												autoComplete="off"
												onChange={handleInputChange}
												value={searchTemp}
												style={{
													padding: " 0 0 0 5px",
													height: "34px",
												}}
											/>
										</div>
										<div
											id="toggle-btnf"
											style={{ height: "37px" }}
											class={"toogle-btn" + (showFilter ? " collapse-state" : "")}
											onClick={() => showAdvFilter("adv_filter")}
										>
											<svg
												width="20"
												height="17"
												viewBox="0 0 20 17"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M7.83333 12.5H11.1667V11.3571H7.83333V12.5ZM4.5 9.07143H14.5V7.92857H4.5V9.07143ZM2 4.5V5.64286H17V4.5H2Z"
													fill="#303049"
												></path>
											</svg>
										</div>

										<div
											className="toogle-btn"
											onClick={resetHandler}
											style={{ lineHeight: "1px", height: "37px" }}
										>
											<span>
												<svg
													width="16"
													height="16"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M0.666748 2.66666V6.66666H4.66675"
														stroke="#202223"
														stroke-opacity="0.5"
														stroke-width="1.33"
														stroke-linecap="round"
														stroke-linejoin="round"
													></path>
													<path
														d="M2.34008 10C2.77234 11.2269 3.59164 12.2801 4.67452 13.0009C5.7574 13.7217 7.0452 14.0711 8.34389 13.9963C9.64258 13.9216 10.8818 13.4268 11.8748 12.5865C12.8679 11.7462 13.5609 10.606 13.8496 9.33758C14.1382 8.06917 14.0068 6.74131 13.4752 5.55407C12.9435 4.36684 12.0404 3.38454 10.902 2.75518C9.76351 2.12583 8.45135 1.88352 7.1632 2.06475C5.87505 2.24599 4.68069 2.84095 3.76008 3.76001L0.666748 6.66667"
														stroke="#202223"
														stroke-opacity="0.5"
														stroke-width="1.33"
														stroke-linecap="round"
														stroke-linejoin="round"
													></path>
												</svg>
											</span>
										</div>
										{/* <div className="toogle-btn" onClick={resetHandler}>
											<span>
												<BiPlus style={{ fontSize: "20px" }} />
											</span>
										</div> */}
										<div style={{ marginLeft: ".5rem" }}>
											<Link
												to="/deals/add"
												className="btn btn-sky mob"
												style={{ height: "37px" }}
											>
												<span className="hidden-sm">Add New Deal</span>
												<span className="mob_icon_plus hidden-md"></span>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					{showFilter ? getFilter() : ""}
					{/* Customer List */}
					<div className="body-content" style={{ width: "100%", padding: "10px", background: "#fff" }}>
						<div className="table-wrap" style={{ padding: "5px", minHeight: "60vh" }}>
							<table style={{ tableLayout: "fixed" }}>
								<thead>
									<tr>
										<th width="60">
											<div className="d-flex align-items-center justify-content-between parentDiv">
												ID
												<i
													className={`fas fa-${sortTypes[sortStates.milestone_id] ? sortTypes[sortStates.milestone_id].class : "sort"}`}
													onClick={() => onSortChange("milestone_id")}
													style={getIconStyle("milestone_id")}
												></i>
											</div>
										</th>
										<th width="370">
											<div className="d-flex align-items-center justify-content-between parentDiv">
												Deal Title
												{/* {addShortFilter("deal_name")} */}
											</div>
										</th>
										<th width="230">
											<div className="d-flex align-items-center justify-content-between parentDiv">
												Account Name
												{/* {addShortFilter("company_name")} */}
											</div>
										</th>
										<th width="230">
											<div className="d-flex align-items-center justify-content-between parentDiv">
												Product
												{/* {addShortFilter("name")} */}
											</div>
										</th>

										<th width="120">
											<div className="d-flex align-items-center justify-content-between parentDiv">
												Due Date
												{/* {addShortFilter("milestone_due")} */}
												<i
													className={`fas fa-${sortTypes[sortStates.milestone_due].class}`}
													onClick={() => onSortChange("milestone_due")}
													style={getIconStyle("milestone_due")}
												></i>
											</div>
										</th>

										<th width="120">
											<div className="d-flex align-items-center justify-content-between parentDiv">
												Amount ($)
												{/* {addShortFilter("milestone_amount")} */}
												<i
													className={`fas fa-${sortTypes[sortStates.milestone_amount] && sortTypes[sortStates.milestone_amount].class
														? sortTypes[sortStates.milestone_amount].class
														: "sort"
														}`}
													onClick={() => onSortChange("milestone_amount")}
													style={getIconStyle("milestone_amount")}
												></i>
											</div>
										</th>
										<th width="120">
											<div className="d-flex align-items-center justify-content-between parentDiv">
												Received
												{/* {addShortFilter("milestone_receive")} */}
												<i
													className={`fas fa-${sortStates.milestone_receive && sortTypes[sortStates.milestone_receive]
														? sortTypes[sortStates.milestone_receive].class
														: "sort"
														}`}
													onClick={() => onSortChange("milestone_receive")}
													style={getIconStyle("milestone_receive")}
												></i>
											</div>
										</th>
										<th width="80">
											<div className="d-flex align-items-center justify-content-between parentDiv">
												State
												{/* {addShortFilter("deal_state")} */}
											</div>
										</th>
										<th width="120">
											<div className="d-flex align-items-center justify-content-between parentDiv">
												Deal Status
												{/* {addShortFilter("deal_status")} */}
											</div>
										</th>
										<th width="160">
											<div className="d-flex align-items-center justify-content-between parentDiv">
												Payment Status
												{/* {addShortFilter("milestone_status")} */}
											</div>
										</th>
										<th width="160">
											<div className="d-flex align-items-center justify-content-between parentDiv">
												Created Date
											</div>
										</th>

										<th width="10" className="fixed-col-deal"></th>
									</tr>
								</thead>
								<tbody>
									{loading ? (
										<tr>
											<div className="row" style={{ width: window.innerWidth - 210 }}>
												<div className="loader-new"></div>
											</div>
										</tr>
									) : (
										dealsList.map((value) => (
											<tr key={value.milestone_uuid}>
												<td>
													<NavLink
														to={{
															pathname: `/deal/${value["deal_uuid"]}`,
															state: { pageNumber: currentPage },
														}}
														className="company-link"
													>
														<span style={{ color: "#006efa" }}> {value.milestone_id}</span>
													</NavLink>
												</td>
												<td>
													<NavLink
														to={{
															pathname: `/deal/${value["deal_uuid"]}`,
															state: { pageNumber: currentPage },
														}}
														className="company-link"
													>
														<span>{(value.milestone_desc || "No Description").slice(0, 50)}{(value.milestone_desc || "").length > 50 ? "..." : ""}</span>
													</NavLink>
												</td>

												<td>
													<NavLink
														to={{
															// pathname: `/account/${value.deals["customer_id"]}`,
															pathname: `/account/${value.deals.user ? value.deals.user.customer_id : "unknown"}`,
															state: { pageNumber: currentPage },
														}}
														className="company-link"
													>
														{
															value.deals && value.deals.user && value.deals.user.company_name ? (
																<img
																	src={`https://ui-avatars.com/api/?name=${value.deals.user.company_name}&color=ff0000&size=40&background=random`}
																	alt="Logo"
																	className="user-image rounded"
																	style={{
																		width: "30px",
																		height: "30px",
																		borderRadius: "50%",
																		marginRight: "5px",
																		objectFit: "contain",
																	}}
																/>
															) : (
																value.deals && value.deals.user && value.deals.user.email ? (
																	<img
																		src={`https://ui-avatars.com/api/?name=${(value.deals.user.email || "").split("@")[0] || "UNKNOWN"}&color=ff0000&size=40&background=random`}
																		alt="Logo"
																		className="user-image rounded"
																		style={{
																			width: "30px",
																			height: "30px",
																			borderRadius: "50%",
																			marginRight: "5px",
																			objectFit: "contain",
																		}}
																	/>
																) : (
																	<img
																		src={`https://ui-avatars.com/api/?name=UNKNOWN&color=ff0000&size=40&background=random`}
																		alt="Logo"
																		className="user-image rounded"
																		style={{
																			width: "30px",
																			height: "30px",
																			borderRadius: "50%",
																			marginRight: "5px",
																			objectFit: "contain",
																		}}
																	/>
																)
															)
														}
														{/* <img
															src={value.deals.user && value.deals.user["logo"]}
															alt="Logo"
															className="user-image rounded"
															style={{
																width: "30px",
																height: "30px",
																borderRadius: "50%",
																marginRight: "5px",
																objectFit: "contain",
															}}
														/> */}
														&nbsp;
														{value.deals.user && value.deals.user["company_name"]}
													</NavLink>
												</td>
												<td>
													<span
														data-toggle="tooltip"
														data-placement="right"
														title={getProductNames(value.deals.product)}
													>
														{truncateStringAfterWords(
															getProductNames(value.deals.product),
															5
														)}
													</span>
												</td>

												<td>
													{new Date(value.milestone_due * 1000).toLocaleDateString("en-US", {
														year: "numeric",
														month: "short",
														day: "numeric",
													})}
												</td>

												{/* <td>{value.milestone_sl_no}</td> */}
												<td>$ {value.milestone_amount}</td>
												<td>
													{value.milestone_receive
														? new Date(value.milestone_receive * 1000).toLocaleDateString(
															"en-US",
															{
																year: "numeric",
																month: "short",
																day: "numeric",
															}
														)
														: "-NA-"}
												</td>
												<td>{value.deals.deal_state}</td>
												<td>
													{value.deals.deal_status ? (
														<p className="bagde-customer">Open</p>
													) : (
														<p className="badge-close">Close</p>
													)}
												</td>
												<td>
													{value.milestone_status == "Paid" ? (
														<p className="bagde-customer">Paid</p>
													) : value.milestone_status == "Due" ? (
														new Date(currentUnixTime) >
															new Date(convertUnixTimeStampToDate(value.milestone_due)) ? (
															<p className="bagde-danger">Overdue</p>
														) : (
															<p className="bagde-warning">Due</p>
														)
													) : value.milestone_status == "Lost" ? (
														<p className="bagde-internal">Lost</p>
													) : (
														<p className="badge-yellow">Draft</p>
													)}
												</td>
												<td>
													{value.deals && value.deals.created_at ? (
														getFormattedDate(value.deals.created_at, "MMM, dd yyyy")
													) : ("N/A")}
												</td>

												<td className="text-center fixed-col-deal">
													{isGeneralUser != 1 ? (
														<div className="dropdown">
															<button
																class="btn btn-default dropdown-toggle"
																type="button"
																id="dropdownMenu2"
																data-toggle="dropdown"
																aria-haspopup="true"
																aria-expanded="false"
																style={{ margin: "15px -15px" }}
															>
																<svg
																	width="30"
																	height="30"
																	viewBox="0 0 16 16"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		d="M7.99992 8.66668C8.36811 8.66668 8.66659 8.3682 8.66659 8.00001C8.66659 7.63182 8.36811 7.33334 7.99992 7.33334C7.63173 7.33334 7.33325 7.63182 7.33325 8.00001C7.33325 8.3682 7.63173 8.66668 7.99992 8.66668Z"
																		fill="#373945"
																		stroke="#373945"
																		stroke-linecap="round"
																		stroke-linejoin="round"
																	/>
																	<path
																		d="M7.99992 3.99999C8.36811 3.99999 8.66659 3.70151 8.66659 3.33332C8.66659 2.96513 8.36811 2.66666 7.99992 2.66666C7.63173 2.66666 7.33325 2.96513 7.33325 3.33332C7.33325 3.70151 7.63173 3.99999 7.99992 3.99999Z"
																		fill="#373945"
																		stroke="#373945"
																		stroke-linecap="round"
																		stroke-linejoin="round"
																	/>
																	<path
																		d="M7.99992 13.3333C8.36811 13.3333 8.66659 13.0349 8.66659 12.6667C8.66659 12.2985 8.36811 12 7.99992 12C7.63173 12 7.33325 12.2985 7.33325 12.6667C7.33325 13.0349 7.63173 13.3333 7.99992 13.3333Z"
																		fill="#373945"
																		stroke="#373945"
																		stroke-linecap="round"
																		stroke-linejoin="round"
																	/>
																</svg>
															</button>
															{showActionColumnData(value)}
														</div>
													) : (
														""
													)}
												</td>
											</tr>
										))
									)}

									{loading ? (
										""
									) : totalCount > 0 ? (
										""
									) : (
										<tr>
											<td
												colSpan={10}
												style={{
													textAlign: "center",
													height: "370px",
												}}
											>
												<svg
													width="56"
													height="56"
													viewBox="0 0 56 56"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<g clip-path="url(#clip0_504_30600)">
														<path
															d="M48.5215 39.9595C48.959 40.7456 49.8374 41.1301 50.738 41.125C52.2693 41.1182 53.4963 42.4221 53.3647 43.979C53.2485 45.3582 52.0044 46.375 50.6201 46.375H42V47.25H6.12498C4.62791 47.25 3.42479 45.9973 3.5034 44.4849C3.5786 43.0647 4.85179 42 6.27366 42H6.99998C8.06297 42 8.90379 41.0532 8.72606 39.9561C8.58592 39.0964 7.77757 38.5 6.90599 38.5H2.62498C1.12791 38.5 -0.0752122 37.2473 0.00340108 35.7349C0.0785966 34.3147 1.35179 33.25 2.77366 33.25H8.31248C9.52073 33.25 10.5 32.2708 10.5 31.0625C10.5 29.8542 9.52073 28.875 8.31248 28.875C7.10423 28.875 6.12498 27.8958 6.12498 26.6875C6.12498 25.4792 7.10423 24.5 8.31248 24.5H15.75V18.375H9.18748C7.44261 18.375 6.03612 16.9138 6.13011 15.1484C6.21556 13.4924 7.70237 12.25 9.36009 12.25H15.75V8.75H49.4375C51.1824 8.75 52.5888 10.2112 52.4949 11.9766C52.4094 13.6326 50.9226 14.875 49.2649 14.875H46.8125C45.0676 14.875 43.6611 16.3362 43.7551 18.1016C43.8406 19.7576 45.3274 21 46.9851 21H49C50.5552 21 51.7942 22.3535 51.6062 23.9446C51.449 25.2656 50.2527 26.1953 48.9248 26.2517C47.8772 26.2944 47.0688 27.26 47.2842 28.3555C47.4499 29.186 48.2326 29.75 49.0786 29.75H52.9375C54.6824 29.75 56.0888 31.2112 55.9949 32.9766C55.9094 34.6326 54.4226 35.875 52.7649 35.875H50.75C48.8325 35.875 47.3952 37.9309 48.5215 39.9595ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875Z"
															fill="#EFF6FE"
														></path>
														<path
															d="M12.8 49V7H34.7516L45.2 17.4484V49H12.8Z"
															fill="white"
														></path>
														<path
															d="M33.6747 7.60002C34.2052 7.60002 34.7139 7.81074 35.0889 8.18581L44.0142 17.111C44.3892 17.4861 44.6 17.9948 44.6 18.5253V46.4C44.6 47.5046 43.7045 48.4 42.6 48.4H15.4C14.2954 48.4 13.4 47.5046 13.4 46.4V9.60002C13.4 8.49545 14.2954 7.60002 15.4 7.60002H33.6747ZM35.5857 6.98581C35.2107 6.61074 34.702 6.40002 34.1715 6.40002H14.2C13.0954 6.40002 12.2 7.29545 12.2 8.40002V47.6C12.2 48.7046 13.0954 49.6 14.2 49.6H43.8C44.9045 49.6 45.8 48.7046 45.8 47.6V18.0285C45.8 17.498 45.5892 16.9893 45.2142 16.6142L35.5857 6.98581Z"
															fill="#E2EAF3"
														></path>
														<path
															d="M34.4 17.8V7H34.7516L45.2 17.4484V17.8H34.4Z"
															fill="white"
														></path>
														<path
															d="M35 8.09682L44.1032 17.2H37C35.8955 17.2 35 16.3046 35 15.2V8.09682ZM35 6.40002H33.8V16.4C33.8 17.5046 34.6955 18.4 35.8 18.4H45.8V17.2L35 6.40002Z"
															fill="#E2EAF3"
														></path>
														<path
															d="M32.6 29.4028L29 32.8L34.4648 38.8H38.6V35.2L32.6 29.4028Z"
															fill="#7AADF0"
														></path>
														<path
															d="M36.2 22C35.5635 22 34.9531 22.2529 34.503 22.7029C34.0529 23.153 33.8 23.7635 33.8 24.4C33.8 25.0365 34.0529 25.647 34.503 26.0971C34.9531 26.5471 35.5635 26.8 36.2 26.8C36.8365 26.8 37.447 26.5471 37.8971 26.0971C38.3472 25.647 38.6 25.0365 38.6 24.4C38.6 23.7635 38.3472 23.153 37.8971 22.7029C37.447 22.2529 36.8365 22 36.2 22ZM36.2 38.8H19.4V34L25.4 28L36.2 38.8Z"
															fill="#B5DEFF"
														></path>
													</g>
													<defs>
														<clipPath id="clip0_504_30600">
															<rect width="56" height="56" fill="white"></rect>
														</clipPath>
													</defs>
												</svg>
												<div class="mt-3">No Data found</div>
											</td>
										</tr>
									)}

									<RaiseCustomInvoice data={raiseCustomInvoiceModalData} setApiRun={setApiRun} />
									<MarkAsPaid data={markAsPaidModalData} setApiRun={setApiRun} />
									<Confirm data={confirmModalData} />
								</tbody>
							</table>
						</div>
					</div>

					{/* Pagination */}
					{totalCount > 0 ? (
						<div
							class="d-flex mu-pagination justify-content-between align-items-center"
							aria-label="Page navigation example"
						>
							<div class="txt-dark">
								Showing {offSet + 1 + " - " + (offSet + perPage)} of {totalCount}
							</div>
							<div class="mu-pagination">
								<Pagination
									activePage={currentPage}
									itemsCountPerPage={20}
									totalItemsCount={totalCount}
									pageRangeDisplayed={5}
									itemClass="page-item"
									linkClass="page-link"
									onChange={handlePageChange}
								/>
							</div>
						</div>
					) : (
						""
					)}
				</div>
			</div>
		</div>
	);
};

const styleObj = {
	intra_col_10: {
		width: "10%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_12: {
		width: "12%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_15: {
		width: "15%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_18: {
		width: "18%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_8: {
		width: "8%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_2: {
		width: "2%",
	},
};

export default DealsOld;



// WEBPACK FOOTER //
// ./src/components/crm/deals-old/Deals.js